/* localstorage */
import Vue from 'vue'

const SERVICE = 'TEMPLATE'
const MODULE = 'ADMIN'

const storage = {
  setItem: (key, val) => {
    localStorage.setItem(`${SERVICE}-${MODULE}.${key}`, val)
  },
  getItem: (key) => {
    return localStorage.getItem(`${SERVICE}-${MODULE}.${key}`)
  }
}

Vue.prototype.$localstorage = storage
